
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import ClientExperienceShell from "../components/ClientExperienceShell";
import CalBookingEmbed from "../components/CalBookingEmbed";
import servicesCatalog from "../../../shared/data/services.json";
import "./styles/BookingPage.css";

function BookingPage() {
  const navigate = useNavigate();
  const { serviceId } = useParams();

  const selectedService = useMemo(
    () => servicesCatalog.services.find((service) => service.id === serviceId),
    [serviceId]
  );

  const bookingUrl = selectedService?.calBookingUrl || "";
  const pageTitle = selectedService ? `Book ${selectedService.name}` : "Book an Appointment";

  return (
    <ClientExperienceShell className="booking-page-shell">
      <main className="client-stage-page booking-page-content">
        <section className="client-page-header minimal-client-header">
          <div className="minimal-client-header-row">
            <button
              className="back-button"
              aria-label="Back"
              onClick={() => navigate("/services")}
              type="button"
            >
              ←
            </button>
            <h1>{pageTitle}</h1>
          </div>
        </section>
        <CalBookingEmbed bookingUrl={bookingUrl} title="Booking calendar" />
      </main>
    </ClientExperienceShell>
  );
}

export default BookingPage;
